'use client';

import * as DS from '@aurorasolar/ds';

import { TermsConditionsBody } from '@/app/terms';

export const TermsContent = () => (
  <DS.Flex gap={0} maxW={DS.BorealisTheme.screens.lg} mx="auto">
    <TermsConditionsBody />
    <DS.Divider />
  </DS.Flex>
);
